module.exports = __webpack_public_path__ + "static/media/dougu_open_banner_zh.012bc42e.png";